import { memo } from 'react';
import { useLocation } from 'react-router-dom';

import { AccountNotice } from '@webapp/account/src/components/account-notice';
import { Footer } from '@webapp/account/src/components/layout/footer';
import { AccountRoutes } from '@webapp/account/src/resources/routes';

import { Header } from '@webapp/common/components/header';
import { ColorScheme } from '@webapp/common/lib/ui';

import { BlockedServicePopup } from './blocked-dialog';

import css from './layout.css';

export const Layout: FC<{
    notice: ReactNode;
    children?: ReactNode;
}> = memo(({ children, notice }) => {
    const { pathname } = useLocation();
    const preview = pathname.startsWith(AccountRoutes.preview.root);

    return (
        <div className={preview ? '' : css.page}>
            <BlockedServicePopup />
            {!preview && (
                <Header className={css.header} logoLink={AccountRoutes.account.link} mode={ColorScheme.DARK} />
            )}
            {notice && <AccountNotice closable content={notice} />}
            <div className={css.content}>{children}</div>
            {!preview && <Footer />}
        </div>
    );
});
Layout.displayName = 'Layout';
